import { Button, ButtonProps } from 'antd';
import { CloseOutlined } from '@ant-design/icons';

export type CancelButtonProps = ButtonProps;

export function CancelButton(props: CancelButtonProps) {
  return <Button type="primary" icon={<CloseOutlined />} {...props} />;
}
